'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  border-top: 1px solid ', ';\n  display: ', ';\n  padding: 15px 0;\n  width: 100%;\n\n  @media(min-width: ', ') {\n    display: none;\n  }\n'], ['\n  border-top: 1px solid ', ';\n  display: ', ';\n  padding: 15px 0;\n  width: 100%;\n\n  @media(min-width: ', ') {\n    display: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-weight: 500;\n  margin-left: 5px;\n  transition: color ease 0.5s;\n\n  &:hover {\n    text-decoration: underline;\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  font-weight: 500;\n  margin-left: 5px;\n  transition: color ease 0.5s;\n\n  &:hover {\n    text-decoration: underline;\n    color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  margin-left: 5px;\n'], ['\n  margin-left: 5px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../../config.js');

var _TriangleSVG = require('../../../../svg/TriangleSVG');

var _TriangleSVG2 = _interopRequireDefault(_TriangleSVG);

var _LinkAccordion = require('./components/LinkAccordion');

var _LinkAccordion2 = _interopRequireDefault(_LinkAccordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, _config.colors.gray, function (props) {
  return props.$collapse ? 'block' : 'none';
}, _config.breakpoints.m);

Wrapper.displayName = 'Wrapper';

var Link = _styledComponents2.default.a(_templateObject2, _config.colors.red, _config.colors.darkRed);

Link.displayName = 'Link';

var IconWrapper = _styledComponents2.default.span(_templateObject3);

IconWrapper.displayName = 'IconWrapper';

var Collapse = function Collapse(_ref) {
  var title = _ref.title,
      buttonUrl = _ref.buttonUrl,
      _ref$collapse = _ref.collapse,
      collapse = _ref$collapse === undefined ? true : _ref$collapse,
      _ref$links = _ref.links,
      links = _ref$links === undefined ? [] : _ref$links;

  if (links.length) {
    return _react2.default.createElement(_LinkAccordion2.default, {
      collapse: collapse,
      title: title,
      overviewUrl: buttonUrl,
      links: links
    });
  }

  return _react2.default.createElement(
    Wrapper,
    {
      $collapse: collapse
    },
    _react2.default.createElement(
      Link,
      {
        href: buttonUrl
      },
      title
    ),
    _react2.default.createElement(
      IconWrapper,
      null,
      _react2.default.createElement(_TriangleSVG2.default, {
        height: '10px'
      })
    )
  );
};

Collapse.propTypes = {
  title: _propTypes2.default.string.isRequired,
  buttonUrl: _propTypes2.default.string.isRequired,
  collapse: _propTypes2.default.bool,
  links: _propTypes2.default.arrayOf(Object)
};

Collapse.displayName = 'Collapse';

exports.default = Collapse;
Collapse.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Collapse',
  'props': {
    'collapse': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'links': {
      'defaultValue': {
        'value': '[]',
        'computed': false
      },
      'type': {
        'name': 'arrayOf',
        'value': {
          'name': 'custom',
          'raw': 'Object'
        }
      },
      'required': false,
      'description': ''
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    },
    'buttonUrl': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': ''
    }
  }
};